/**
 * Quill + ImageResize bootstrap file.
 *
 * WHY this file exists:
 *   ES `import` statements are statically hoisted by Webpack, so writing
 *   `(window as any).Quill = Quill` between two import lines has NO effect —
 *   both imports execute before any runtime code.
 *
 *   `require()` is a runtime call and is NOT hoisted, so using it here
 *   guarantees execution order:
 *     1. Quill is imported (ES import, top)
 *     2. Quill is assigned to window (runtime, synchronous)
 *     3. quill-image-resize is loaded via require() (runtime, after step 2)
 *     4. The module is registered on the correct Quill instance
 */
import Quill from 'quill';

(window as any).Quill = Quill;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ImageResize = require('quill-image-resize-module');
Quill.register('modules/imageResize', ImageResize.default ?? ImageResize);

// Clamp the Quill link/formula tooltip to stay within the boundaries of the editor container
const Tooltip = Quill.import('ui/tooltip');
if (Tooltip) {
  const originalPosition = Tooltip.prototype.position;
  Tooltip.prototype.position = function (reference: any) {
    const shift = originalPosition.call(this, reference);

    const container = this.quill.container;
    if (container && this.root) {
      const tooltipRect = this.root.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      let currentTop = parseFloat(this.root.style.top);
      let currentLeft = parseFloat(this.root.style.left);

      if (isNaN(currentTop)) currentTop = 0;
      if (isNaN(currentLeft)) currentLeft = 0;

      const tooltipHeight = tooltipRect.height || 40;
      const tooltipWidth = tooltipRect.width || 300;

      // Clamp tooltip to stay inside the editor container boundaries with a 5px margin
      const minTop = 5;
      const maxTop = Math.max(minTop, containerRect.height - tooltipHeight - 5);

      const minLeft = 5;
      const maxLeft = Math.max(minLeft, containerRect.width - tooltipWidth - 5);

      if (currentTop > maxTop) currentTop = maxTop;
      if (currentTop < minTop) currentTop = minTop;

      if (currentLeft > maxLeft) currentLeft = maxLeft;
      if (currentLeft < minLeft) currentLeft = minLeft;

      this.root.style.top = `${currentTop}px`;
      this.root.style.left = `${currentLeft}px`;
    }

    return shift;
  };
}
